// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Более точное центрирование панели */
.main-content {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 100% !important;
  padding-top: 20px !important;
}

/* Установка фиксированной ширины для карточек */
.app-card {
  width: 100% !important;
  max-width: 1000px !important;
  margin: 0 auto 20px auto !important;
}

/* Точное выравнивание кнопок действий по вертикали */
.action-cell {
  height: 72px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Установка высоты для всех ячеек таблицы */
.ant-table-row td.ant-table-cell {
  height: 72px !important;
  padding: 0 16px !important;
  line-height: 1.5 !important;
}

/* Вертикальное центрирование для всех ячеек */
.ant-table-cell {
  vertical-align: middle !important;
}

/* Стили для ячейки с именем */
.name-cell {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* Стили для ячейки с типом */
.type-cell {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* Стили для команды */
.team-cell {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* Убираем внутренние отступы у карточки таблицы для более точного контроля */
.table-card .ant-card-body {
  padding: 0 !important;
}

/* Добавляем отступы для заголовков в таблице */
.ant-table-thead > tr > th {
  padding: 16px !important;
}

/* Исправление для кнопок в строках */
.action-buttons {
  display: flex !important;
  gap: 8px !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Корректировка вертикального выравнивания для первой колонки */
.first-column {
  display: flex !important;
  align-items: center !important;
  height: 72px !important;
}

/* Явное указание стилей для ячеек заголовка таблицы */
.ant-table-cell.column-header {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
  padding: 16px !important;
  height: auto !important;
}

/* Стили для пагинации - оптимизированные */
.footer-pagination-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #ffffff;
  border-top: 1px solid #e8e8e8;
  box-sizing: border-box;
}

/* Фиксированные стили пагинации */


.pagination-buttons-container {
  display: inline-block;
  white-space: nowrap;
  text-align: center;
}

.page-info {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-size-selector span {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

/* Оптимизированные стили для кнопок страниц */
.page-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-button:hover {
  border-color: #e74c3c;
  color: #e74c3c;
}

.page-button:disabled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

/* Убираем дублирование стилей, оставляя только необходимые */
.table-with-footer {
  width: 90%;
  max-width: 900px;
  margin: 0 auto;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Тип приложения */
.type-tag {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ant-table-cell-content {
  padding: 8px 0;
}

.footer-pagination-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #ffffff;
  border-top: 1px solid #e8e8e8;
}

/* Стили для информации о количестве приложений */
.page-info {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

/* Стили для селектора количества строк */
.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-size-selector span {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

/* Новый унифицированный список пагинации */
.pagination-list {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pagination-item {
  margin: 0 4px;
  display: inline-block;
  background-color: #ffffff;
}

.pagination-number {
  min-width: 32px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  padding: 0;
}

.pagination-active {
  background-color: #e74c3c !important;
  border-color: #e74c3c !important;
  color: white !important;
}

.pagination-ellipsis {
  display: inline-block;
  line-height: 32px;
  height: 32px;
  min-width: 32px;
  text-align: center;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.65);
}


/* Исправление для иконок */
.page-button .anticon {
  font-size: 12px;
  display: block;
  
  line-height: 1;
}

button.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined{
  border-color: #2868f1;
  background-color: #2868f1;
}

button.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined:hover{
  border-color: #2868f1;
  background-color: #ffffff;
  color: #2868f1;
}

button.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-primary.ant-btn-color-primary.ant-btn-variant-solid.ant-btn-sm.pagination-active {
  background-color: #ffffff !important;
    border-color: #2868f1 !important;
    color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Apps.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA,qDAAqD;AACrD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,6EAA6E;AAC7E;EACE,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,gEAAgE;AAChE;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,kCAAkC;;;AAGlC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;;AAGA,2BAA2B;AAC3B;EACE,eAAe;EACf,cAAc;;EAEd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;IAClC,gCAAgC;IAChC,uBAAuB;AAC3B","sourcesContent":["/* Более точное центрирование панели */\r\n.main-content {\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  align-items: center !important;\r\n  justify-content: flex-start !important;\r\n  width: 100% !important;\r\n  padding-top: 20px !important;\r\n}\r\n\r\n/* Установка фиксированной ширины для карточек */\r\n.app-card {\r\n  width: 100% !important;\r\n  max-width: 1000px !important;\r\n  margin: 0 auto 20px auto !important;\r\n}\r\n\r\n/* Точное выравнивание кнопок действий по вертикали */\r\n.action-cell {\r\n  height: 72px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n/* Установка высоты для всех ячеек таблицы */\r\n.ant-table-row td.ant-table-cell {\r\n  height: 72px !important;\r\n  padding: 0 16px !important;\r\n  line-height: 1.5 !important;\r\n}\r\n\r\n/* Вертикальное центрирование для всех ячеек */\r\n.ant-table-cell {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n/* Стили для ячейки с именем */\r\n.name-cell {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  height: 100% !important;\r\n}\r\n\r\n/* Стили для ячейки с типом */\r\n.type-cell {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  height: 100% !important;\r\n}\r\n\r\n/* Стили для команды */\r\n.team-cell {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  height: 100% !important;\r\n}\r\n\r\n/* Убираем внутренние отступы у карточки таблицы для более точного контроля */\r\n.table-card .ant-card-body {\r\n  padding: 0 !important;\r\n}\r\n\r\n/* Добавляем отступы для заголовков в таблице */\r\n.ant-table-thead > tr > th {\r\n  padding: 16px !important;\r\n}\r\n\r\n/* Исправление для кнопок в строках */\r\n.action-buttons {\r\n  display: flex !important;\r\n  gap: 8px !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n/* Корректировка вертикального выравнивания для первой колонки */\r\n.first-column {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  height: 72px !important;\r\n}\r\n\r\n/* Явное указание стилей для ячеек заголовка таблицы */\r\n.ant-table-cell.column-header {\r\n  background-color: #f5f5f5 !important;\r\n  font-weight: bold !important;\r\n  padding: 16px !important;\r\n  height: auto !important;\r\n}\r\n\r\n/* Стили для пагинации - оптимизированные */\r\n.footer-pagination-container {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px;\r\n  background-color: #ffffff;\r\n  border-top: 1px solid #e8e8e8;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Фиксированные стили пагинации */\r\n\r\n\r\n.pagination-buttons-container {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n\r\n.page-info {\r\n  color: rgba(0, 0, 0, 0.65);\r\n  font-size: 14px;\r\n}\r\n\r\n.page-size-selector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.page-size-selector span {\r\n  color: rgba(0, 0, 0, 0.65);\r\n  font-size: 14px;\r\n}\r\n\r\n/* Оптимизированные стили для кнопок страниц */\r\n.page-button {\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.page-button:hover {\r\n  border-color: #e74c3c;\r\n  color: #e74c3c;\r\n}\r\n\r\n.page-button:disabled {\r\n  cursor: not-allowed;\r\n  color: rgba(0, 0, 0, 0.25);\r\n  background-color: #f5f5f5;\r\n  border-color: #d9d9d9;\r\n}\r\n\r\n/* Убираем дублирование стилей, оставляя только необходимые */\r\n.table-with-footer {\r\n  width: 90%;\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Тип приложения */\r\n.type-tag {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ant-table-cell-content {\r\n  padding: 8px 0;\r\n}\r\n\r\n.footer-pagination-container {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px;\r\n  background-color: #ffffff;\r\n  border-top: 1px solid #e8e8e8;\r\n}\r\n\r\n/* Стили для информации о количестве приложений */\r\n.page-info {\r\n  color: rgba(0, 0, 0, 0.65);\r\n  font-size: 14px;\r\n}\r\n\r\n/* Стили для селектора количества строк */\r\n.page-size-selector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.page-size-selector span {\r\n  color: rgba(0, 0, 0, 0.65);\r\n  font-size: 14px;\r\n}\r\n\r\n/* Новый унифицированный список пагинации */\r\n.pagination-list {\r\n  display: flex;\r\n  align-items: center;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.pagination-item {\r\n  margin: 0 4px;\r\n  display: inline-block;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.pagination-number {\r\n  min-width: 32px;\r\n  height: 32px;\r\n  line-height: 30px;\r\n  text-align: center;\r\n  padding: 0;\r\n}\r\n\r\n.pagination-active {\r\n  background-color: #e74c3c !important;\r\n  border-color: #e74c3c !important;\r\n  color: white !important;\r\n}\r\n\r\n.pagination-ellipsis {\r\n  display: inline-block;\r\n  line-height: 32px;\r\n  height: 32px;\r\n  min-width: 32px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: rgba(0, 0, 0, 0.65);\r\n}\r\n\r\n\r\n/* Исправление для иконок */\r\n.page-button .anticon {\r\n  font-size: 12px;\r\n  display: block;\r\n  \r\n  line-height: 1;\r\n}\r\n\r\nbutton.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined{\r\n  border-color: #2868f1;\r\n  background-color: #2868f1;\r\n}\r\n\r\nbutton.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined:hover{\r\n  border-color: #2868f1;\r\n  background-color: #ffffff;\r\n  color: #2868f1;\r\n}\r\n\r\nbutton.ant-btn.css-dev-only-do-not-override-1jw6pig.ant-btn-primary.ant-btn-color-primary.ant-btn-variant-solid.ant-btn-sm.pagination-active {\r\n  background-color: #ffffff !important;\r\n    border-color: #2868f1 !important;\r\n    color: black !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
